module.exports = function(service) {
    'use strict';
    service.factory('stripHtml',stripHtml);
	stripHtml.$inject=[];
	function stripHtml() {
        return function(html) {
            if (!html) return '';
            // Replace HTML tags with a space
            var text = html.replace(/<[^>]*>/g, ' ');
            // Normalize multiple spaces/newlines to a single space
            text = text.replace(/\s+/g, ' ').trim();
            return text;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/stripHtmlService.js
// module id = 628
// module chunks = 0